export default {
  hints: {
    recover: '¿Olvidaste tu contraseña?'
  },

  buttons: {
    reset: 'Restablecer',
    request: 'Solicitar'
  }
}
